import { useCallback } from 'react';

import { useAxios } from '../axios';
import { GetTruckerParams, Trucker } from './truckers.types';

export const useGetTruckers = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: Trucker[]; count: number };
  }>({
    method: 'GET',
  });

  const getTruckers = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
      withValidLicenseAndInsurance,
    }: GetTruckerParams) =>
      axiosFetch({
        url: '/counterparty/trucker',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
          withValidLicenseAndInsurance,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getTruckers,
  };
};
